import CompanyCell from 'components/cell/CompanyCell';
import CustomerCell from 'components/cell/CustomerCell';
import JobCell from 'components/cell/JobCell';
import UpdatedAtCell from 'components/cell/UpdatedAtCell';
import LoanStatus from 'components/loan/LoanTable/LoanStatus';
import LoanTableBreakDown from 'components/loan/LoanTable/LoanTableBreakDown';

export const SORTING = {
  PRICE: 'PRICE',
  ID: 'ID',
  LOAN: 'LOAN',
  DEPOSIT: 'DEPOSIT',
  JOB_TITLE: 'JOB_TITLE',
  JOB_ID: 'JOB_ID',
  CUSTOMER: 'CUSTOMER',
  COMPANY: 'COMPANY',
  UPDATED_AT: 'UPDATED_AT',
};

export const ORDER = {
  NORMAL: 'NORMAL',
  INVERSE: 'INVERSE',
};

export const FILTER_TYPES = {
  NONE: 'NONE',
  STATUS: 'STATUS',
};

export const SEARCH_OPTIONS = {
  keys: [
    { name: 'id', weight: 1 },
    { name: 'companyId', weight: 1 },
    { name: 'jobId', weight: 1 },
    { name: 'ownerId', weight: 1 },
    { name: 'externalId', weight: 1 },
    { name: 'createdAt', weight: 1 },
    { name: 'updatedAt', weight: 1 },
    { name: 'jobTitle', weight: 1 },
    { name: 'archived', weight: 1 },
    { name: 'paymentAmount', weight: 1 },
    { name: 'paymentType', weight: 1 },
    { name: 'paymentStatus', weight: 1 },
    { name: 'companyDetails.name', weight: 1 },
    { name: 'companyDetails.email', weight: 1 },
    { name: 'companyDetails.phone', weight: 1 },
    { name: 'customerDetails.firstName', weight: 1 },
    { name: 'customerDetails.lastName', weight: 1 },
    { name: 'customerDetails.email', weight: 1 },
    { name: 'customerDetails.phone', weight: 1 },
    { name: 'customerDetails.postCode', weight: 1 },
    { name: 'customerDetails.addressLine1', weight: 1 },
    { name: 'customerDetails.addressLine2', weight: 1 },
    { name: 'customerDetails.city', weight: 1 },
    { name: 'loanStatus', weight: 1 },
    { name: 'loanProvider', weight: 1 },
    { name: 'xid', weight: 1 },
  ],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};

export const TABLE_COLUMNS = [
  {
    Header: 'Loan',
    accessor: 'totalAmount',
    subAccessors: ['loanStatus', 'id', 'loanProvider'],
    items: [
      {
        action: {
          type: 'price-ascending',
        },
        icon: 'sort-ascending',
        name: 'Sort £ ascending',
      },
      {
        action: {
          type: 'price-descending',
        },
        icon: 'sort-descending',
        name: 'Sort £ descending',
      },
      {
        action: {
          type: 'id-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort payment ID',
      },
    ],
    width: 240,
    minWidth: 100,
    maxWidth: 2000,
    renderComponent: {
      component: LoanStatus,
      value: 'total',
      optionalProps: ['status', 'id', 'provider'],
    },
  },
  {
    Header: 'Breakdown',
    accessor: 'loanAmount',
    subAccessors: ['depositAmount', 'financeOption', 'xid'],
    items: [
      {
        action: {
          type: 'loan-ascending',
        },
        icon: 'sort-ascending',
        name: 'Loan ascending',
      },
      {
        action: {
          type: 'loan-descending',
        },
        icon: 'sort-descending',
        name: 'Loan descending',
      },
      {
        action: {
          type: 'deposit-ascending',
        },
        icon: 'sort-ascending',
        name: 'Deposit ascending',
      },
      {
        action: {
          type: 'deposit-descending',
        },
        icon: 'sort-descending',
        name: 'Deposit descending',
      },
    ],
    width: 180,
    minWidth: 100,
    maxWidth: 2000,
    renderComponent: {
      component: LoanTableBreakDown,
      value: 'loan',
      optionalProps: ['deposit', 'rate', 'xid'],
    },
  },
  {
    Header: 'Job',
    accessor: 'jobTitle',
    subAccessors: ['jobId', 'archived'],
    items: [
      {
        action: {
          type: 'job-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort job title',
      },
      {
        action: {
          type: 'job-id-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort job ID',
      },
    ],
    renderComponent: {
      component: JobCell,
      value: 'title',
      optionalProps: ['id', 'archived'],
    },
    width: 180,
    minWidth: 100,
    maxWidth: 2000,
  },
  {
    Header: 'Customer',
    accessor: 'customerDetails',
    items: [
      {
        action: {
          type: 'name-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort customer name',
      },
    ],
    width: 180,
    minWidth: 120,
    maxWidth: 2000,
    renderComponent: {
      component: CustomerCell,
      value: 'customerDetails',
    },
  },
  {
    Header: 'Company',
    accessor: 'companyName',
    items: [
      {
        action: {
          type: 'company-name-alphabetical',
        },
        icon: 'alphabet',
        name: 'Sort company name',
      },
    ],
    subAccessors: ['companyName', 'companyContactEmail', 'companyContactPhone'],
    width: 220,
    renderComponent: {
      component: CompanyCell,
      value: 'companyName',
      optionalProps: [
        'companyName',
        'companyContactEmail',
        'companyContactPhone',
      ],
    },
  },
  {
    Header: 'Last Activity',
    accessor: 'updatedAt',
    items: [
      {
        action: {
          type: 'activity-ascending',
        },
        icon: 'sort-ascending',
        name: 'Sort ascending',
      },
      {
        action: {
          type: 'activity-descending',
        },
        icon: 'sort-descending',
        name: 'Sort descending',
      },
    ],
    width: 140,
    renderComponent: {
      component: UpdatedAtCell,
      value: 'date',
    },
  },
];

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};
